import api from '@/services/api'
import EntryActions from './actions-types'
import EntryMutations from './mutations-types'

export default {
  [EntryActions.LIST_SUBFOLDER]({ commit }, {parentId, updateList = true}) {
    if (updateList) {
      commit(EntryMutations.SET_ENTRIES, {})
    }

    return new Promise((resolve, reject) => {
      api.content.entry
        .listSubfolder(parentId)
        .then((response) => {
          if (updateList) {
            commit(EntryMutations.SET_ENTRIES, response.data)
          }

          resolve(response.data)
        })
        .catch((error) => reject(error))
    })
  },

  [EntryActions.UPSERT_ENTRY_LIST]({ commit }, {parentId, nodeId}) {
    return new Promise((resolve, reject) => {
      api.content.entry
        .getEntryData(nodeId, true)
        .then((response) => {
          const nodeData = response.data
          if (! nodeData) {
            resolve()
            return
          }

          if (parentId != nodeData.folder_parent_id) {
            resolve()
            return
          }

          commit(EntryMutations.UPSERT_ENTRY, {nodeId, params: nodeData})

          resolve(nodeData)
        })
        .catch((error) => reject(error))
    })
  },

  [EntryActions.GET_ENTRY_DATA]({}, nodeId) {
    return new Promise((resolve, reject) => {
      api.content.entry
        .getEntryData(nodeId)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => reject(error))
    })
  },

  [EntryActions.SEARCH_BY_TERM]({ commit }, params) {
    return new Promise((resolve, reject) => {
      let [searchParams, showBreadcrumb] = params;
      api.content.search
        .searchByTerm(searchParams)
        .then((response) => {
          const list = showBreadcrumb ? {entries: response.data} : {entries: response.data, breadcrumb: []}
          commit(EntryMutations.SET_ENTRIES, list)
          resolve(list)
        })
        .catch((error) => reject(error))
    })
  },

  [EntryActions.GET_ENTRY_PARENTS_IDS]({}, nodeId) {
    return new Promise((resolve, reject) => {
      api.content.entry
        .getParentsFromEntry(nodeId)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => reject(error))
    })
  },

  [EntryActions.CHECK_COPY_MOVE_POSSIBILITY]({}, params) {
    return new Promise((resolve, reject) => {
      api.content.entry
        .checkCopyMovePossibility(params)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },

  [EntryActions.CHECK_ENTRY_NAME_EXISTS]({}, params) {
    return new Promise((resolve, reject) => {
      api.content.entry
        .checkEntryNameExists(params)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error))
    })
  },

  [EntryActions.HANDLE_LOCK_MESSAGE]({ state, commit }, message) {
    if (!message.text) {
      return
    }

    let parsedMessage
    try {
      parsedMessage = JSON.parse(message.text)
    } catch (error) {
      console.error('Error parsing lock message text:', error)
      return
    }

    const nodeIds = parsedMessage.node_ids
    const lockToken = parsedMessage.lock_token

    if (!nodeIds || !Array.isArray(nodeIds) || nodeIds.length === 0) {
      return
    }

    if (!lockToken) {
      return
    }

    // Filter node_ids to only those present in current state or breadcrumb
    const relevantNodeIds = nodeIds.filter(nodeId => {
      const inEntries = state.entries.some(e => e.node_id == nodeId)
      const inBreadcrumb = state.breadcrumb.some(b => b.node_id == nodeId)
      return inEntries || inBreadcrumb
    })

    if (relevantNodeIds.length === 0) {
      return
    }

    const updateNodeLocks = (nodeId, locks) => {
      // Check if node exists in entries
      const entryIndex = state.entries.findIndex(e => e.node_id == nodeId)
      if (entryIndex >= 0) {
        commit(EntryMutations.UPDATE_ENTRY, {nodeId, params: {locks}})
      }

      // Check if node exists in breadcrumb
      const breadcrumbIndex = state.breadcrumb.findIndex(b => b.node_id == nodeId)
      if (breadcrumbIndex >= 0) {
        const updatedBreadcrumb = [...state.breadcrumb]
        updatedBreadcrumb[breadcrumbIndex] = {
          ...updatedBreadcrumb[breadcrumbIndex],
          locks
        }
        commit(EntryMutations.SET_ENTRIES, {
          entries: state.entries,
          breadcrumb: updatedBreadcrumb
        })
      }
    }

    api.node.nodelock
      .checkNode({base_array: relevantNodeIds})
      .then((response) => {
        const lockData = response.data

        if (!lockData || !Array.isArray(lockData)) {
          return
        }

        const locksByNodeId = lockData.reduce((acc, lock) => {
          if (lock.node_id) {
            if (!acc[lock.node_id]) {
              acc[lock.node_id] = []
            }

            acc[lock.node_id].push(lock)
          }
          return acc
        }, {})

        // Update all relevant nodes (even those with no locks)
        relevantNodeIds.forEach(nodeId => {
          const locks = locksByNodeId[nodeId] || []
          updateNodeLocks(nodeId, locks)
        })
      })
      .catch((error) => {
        console.error('Error checking locks:', error)
      })
  },
}
